/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Charactergreetingluni2Inputs */



/**
* | output |
* | --- |
* | "Talk with me to start the search" |
*
* @param {Charactergreetingluni2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const charactergreetingluni2 = /** @type {((inputs?: Charactergreetingluni2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Charactergreetingluni2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Talk with me to start the search")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habla conmigo para buscar")
	return /** @type {LocalizedString} */ ("Для поиска — поговори со мной")
});
export { charactergreetingluni2 as "characterGreetingLuni" }